import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';

/**
 * The core's generic creation fields (`AppCapacityPicker`,
 * `AppBranchesPicker`), for upstream's form too — a module of the
 * `scaffolder` plugin like `projectNamePickerModule`: each
 * `FormFieldBlueprint` attaches to the scaffolder's form fields, its
 * component loaded lazily with them. There, a template names its type in
 * the fields' `ui:options.appType` (upstream's form tells a field neither
 * the type nor the template); the generic wizard tells them itself.
 */
const appCapacityPickerField = FormFieldBlueprint.make({
  name: 'app-capacity-picker',
  params: {
    field: async () => {
      const { AppCapacityPicker, appCapacityPickerValidation } = await import(
        './AppCapacityPicker'
      );
      return createFormField({
        name: 'AppCapacityPicker',
        component: AppCapacityPicker,
        validation: appCapacityPickerValidation,
        schema: makeFieldSchema({
          output: z =>
            z.object({
              appType: z.string(),
              profile: z.string(),
              values: z.record(z.union([z.number(), z.boolean(), z.string()])),
            }),
          uiOptions: z =>
            z.object({
              appType: z.string().optional(),
              capacityDetails: z.string().optional(),
              haDetails: z.string().optional(),
            }),
        }),
      });
    },
  },
});

const appBranchesPickerField = FormFieldBlueprint.make({
  name: 'app-branches-picker',
  params: {
    field: async () => {
      const { AppBranchesPicker, appBranchesPickerValidation } = await import(
        './AppBranchesPicker'
      );
      return createFormField({
        name: 'AppBranchesPicker',
        component: AppBranchesPicker,
        validation: appBranchesPickerValidation,
        schema: makeFieldSchema({
          output: z => z.array(z.string()),
          uiOptions: z =>
            z.object({
              baseDomain: z.string(),
              appType: z.string().optional(),
            }),
        }),
      });
    },
  },
});

export default createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [appCapacityPickerField, appBranchesPickerField],
});
